export enum PartnerAnalyticsEnum {
  VIEW_PARTNER_PAGE = '[PAC WEB] Perfil da Clínica - Página visualizada',
  CLICK_PARTNER_ADDRESS = '[PAC WEB] Perfil da Clínica - Clicou em "Ver endereço"',
  CLICK_PARTNER_AVATAR = '[PAC WEB] Perfil da Clínica - Clicou no avatar ',
  CLICK_PARTNER_ABOUT_TAB = '[PAC WEB] Perfil da Clínica - Clicou na aba "Sobre"',
  CLICK_PARTNER_REVIEW_TAB = '[PAC WEB] Perfil da Clínica - Clicou na aba "Avaliações"',
  CLICK_PARTNER_SHARE_PROFILE = '[PAC WEB] Perfil da Clínica - Clicou em "Compartilhar perfil"',
  CLICK_PARTNER_REDIRECT_MODAL = '[PAC WEB] Perfil clínica - Selecionou redirecionamento na modal',

  VIEW_PARTNER_INDEX_PAGE = '[PAC WEB] Índice do Parceiro - Página visualizada',

  CLICK_OPEN_MODAL_PARTNERS_INDEX = '[PAC WEB] Índice Parceiros - Clicou em "Filtrar por letra"',
  CLICK_LETTER_PARTNERS_INDEX = '[PAC WEB] Índice Parceiros - Expandiu letra',
  CLICK_CLEAR_FILTER_PARTNERS_INDEX = '[PAC WEB] Índice Parceiros - Clicou em "Limpar filtro"',

  CLICK_SEE_MORE_PARTNERS = '[PAC WEB] Indice Parceiros - Clicou em "Ver mais"',
  VIEW_PARTNERS_BY_LETTER_PAGE = '[PAC WEB] Índice Parceiros - Visualizou página de parceiros por letra',

  CLICK_PARTNER_REVIEW = '[PAC WEB] Perfil da Clínica - Clicou em avaliações e comentários',
  CLICK_PARTNER_OPEN_MAP = '[PAC WEB] Perfil da Clínica - Clicou em "Abrir no mapa"',
  CLICK_PARTNER_ABOUT_PLACE = '[PAC WEB] Perfil da Clínica - Expandiu "Sobre o local"',
  CLICK_PARTNER_SUPPORTED_PROCEDURES = '[PAC WEB] Perfil da Clínica - Expandiu "Especialidades atendidas"',
  CLICK_PARTNER_SHOW_MORE_COMMENTARIES = '[PAC WEB] Perfil da Clínica - Clicou em "Mostrar mais comentários"',
  CLICK_PARTNER_EXPAND_COMMENTARY = '[PAC WEB] Perfil da Clínica - Expandiu comentário',
  CLICK_PARTNER_SHOW_MORE_PROFESSIONAL = '[PAC WEB] Perfil da Clínica - Clicou em "Mostrar mais profissionais"',

  CLICK_PARTNER_REDIRECT_SERVICES_SCHEDULE = '[PAC WEB] Perfil da Clínica - Selecionou redirecionamento (serviços e horários)',
  VIEW_PARTNER_MODAL_REDIRECT = '[PAC WEB] Perfil da Clínica - Modal - Exibiu aviso de redirecionamento',
  CLICK_PARTNER_CONFIRM_REDIRECT = '[PAC WEB] Perfil da Clínica - Modal - Confirmou redirecionamento',
  CLICK_PARTNER_MODAL_CANCEL_REDIRECT = '[PAC WEB] Perfil da Clínica - Modal - Cancelou redirecionamento',
  CLICK_PARTNER_OTHER_PARTNER = '[PAC WEB] Perfil da Clínica - Clicou em outro profissional',
}
